import { useEffect } from 'react';

type ElementRef = {
  current: any | null;
};

/**
 * given a ref, invoke a callback when there is a click outside of this element
 * or its children.
 */
export const useOutsideClick = (
  elementRef: ElementRef,
  onOutsideClickCallback: () => void,
) => {
  useEffect(() => {
    const onOutsideClick = (evt: MouseEvent) => {
      if (!elementRef.current) {
        return;
      }
      const insideTarget = elementRef.current.contains(evt.target);
      if (!insideTarget) {
        onOutsideClickCallback();
      }
    };

    document.body.addEventListener('click', onOutsideClick);

    return () => {
      document.body.removeEventListener('click', onOutsideClick);
    };
  }, [onOutsideClickCallback, elementRef.current]);
};
